import { render, staticRenderFns } from "./LocalityDelete.vue?vue&type=template&id=5458ebfe"
import script from "./LocalityDelete.vue?vue&type=script&lang=js"
export * from "./LocalityDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports